import * as React from 'react';
import { TextInput, Checkbox } from "soprasteria-ui-library";
import { ICareProvider } from '../../../../models/ICareProvider';
import { CareProviderDropdown } from '../../../CareProviderDropdown/CareProviderDropdown';
import { formatAddress } from '../../../../helpers/AddressHelper';


interface IReferralReferrerManualRegistration {
    careProviders: ICareProvider[];
    showOtherReferrer: (val: boolean) => void;
}

export const ReferralReferrerManualRegistration: React.FunctionComponent<IReferralReferrerManualRegistration> = ({ careProviders, showOtherReferrer }) => {

    const [otherReferrerChecked, setOtherReferrerChecked] = React.useState<boolean>(false);
    const [toggleCareProviderResetValue, setToggleCareProviderResetValue] = React.useState<boolean>();
    const [selectedCareProvider, setSelectedCareProvider] = React.useState<ICareProvider>();

    const onCheckboxChange = (checked: boolean) => {
        setToggleCareProviderResetValue(!toggleCareProviderResetValue);
        setOtherReferrerChecked(checked);
        showOtherReferrer(checked);
    }

    const onCareProviderChange = (careProviderId: string) => {
        setSelectedCareProvider(careProviders.find(c => c.careProviderId.toString() == careProviderId));
    }

    return (
        <>
            <div className="row">
                <h5 className="col-12">Remitterande behandlare</h5>
                <div className="col-6">
                    <TextInput name="referrerName" label="Namn" required inlineLabel />
                </div>
                <div className="col-6">
                    <TextInput name="externalIdFromReferrer" label="Remittents remiss-ID" inlineLabel />
                </div>
                <div className="col-6">
                    <CareProviderDropdown
                        name="referrerCareProviderId"
                        careProviders={careProviders}
                        isLoading={false}
                        required={!otherReferrerChecked}
                        disabled={otherReferrerChecked}
                        resetValue={toggleCareProviderResetValue}
                        onValueChange={onCareProviderChange}
                    />
                </div>
                <div className="col-6">
                </div>
                <div className="col-6">
                    <Checkbox name="otherReferrer" id="other-referrer" label="Vårdgivare finns ej i listan" value="otherReferrer" onChange={onCheckboxChange} />
                </div>
            </div>
            {
                selectedCareProvider ?
                    < div className="row readonly-less-margin">
                        <div className="col-6">
                            <TextInput name="readonlyReferrerOrganisationNumber" label="Vårdgivare" defaultValue={selectedCareProvider?.displayOrganisationInformation} inlineLabel readonly />
                        </div>
                        <div className="col-6">
                            <TextInput name="readonlyReferrername" label="Mottagning" defaultValue={selectedCareProvider?.displayCareProviderName} inlineLabel readonly />
                        </div>
                        <div className="col-6">
                            <TextInput name="readonlyReferrerAddress" label="Adress" defaultValue={selectedCareProvider?.address ? formatAddress(selectedCareProvider?.address) : "Saknas"} inlineLabel readonly />
                        </div>
                        <div className="col-6">
                            <TextInput name="readonlyReferrerEmail" label="E-post" defaultValue={selectedCareProvider?.address?.emailAddress ?? "Saknas"} inlineLabel readonly />
                        </div>
                        <div className="col-6">
                            <TextInput name="readonlyReferrerPhoneNumber" label="Telefonnummer" defaultValue={selectedCareProvider?.address?.phoneNumber ?? "Saknas"} inlineLabel readonly />
                        </div>
                    </div>
                    : null
            }
        </>
    )
}